/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const CreditNote = ({
  contactDetails,
}) => {
  const {
    isAdmin,
    RL_Address,
    RL_Name,
    redacted,
  } = useSelector((state) => state);
  const customer = contactDetails[0];
  return (
    <>
      <section>
        <article className="justify-between">
          <p>{RL_Name}: {isAdmin ? (customer?.Name?.FullName || '') : redacted}</p>
        </article>
        <article>
          <p>{RL_Address}: {isAdmin ? (customer?.Addresses?.[0]?.AddressLines?.map((addressLine) => addressLine.Line).join(' ') || '') : redacted}</p>
        </article>
        <article className="justify-between">
          <p>Tax ID / Passport No.: {(customer?.PersonalID?.ID || '') }</p>
        </article>
        <article className="justify-between">
          <p>Credit Note No.: { (customer?.TaxInvoice?.Number || '') }</p>
        </article>
        <article className="justify-between">
          <p>Original Tax Invoice No.: { (customer?.OriginalTaxInvoice?.Number || '') }</p>
        </article>
      </section>
      <br />
    </>
  );
};

CreditNote.defaultProps = {
  contactDetails: {},
};

CreditNote.propTypes = {
  contactDetails: PropTypes.arrayOf(PropTypes.shape()),
};

export default CreditNote;
